import { render } from "./ActiveCommentWidget.vue.js?vue&type=template&id=3a5accc0!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ActiveCommentWidget.vue?vue&type=template&id=3a5accc0"
import script from "./ActiveCommentWidget.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ActiveCommentWidget.vue?vue&type=script&lang=js"
export * from "./ActiveCommentWidget.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ActiveCommentWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/components/community/chatrooms/comments/ActiveCommentWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a5accc0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a5accc0', __exports__)) {
    api.reload('3a5accc0', __exports__)
  }
  
  module.hot.accept("./ActiveCommentWidget.vue.js?vue&type=template&id=3a5accc0!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ActiveCommentWidget.vue?vue&type=template&id=3a5accc0", () => {
    api.rerender('3a5accc0', render)
  })

}


export default __exports__